import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ReportTicketComparativeRepository} from "@dropDesk/domain/repositories/reports/report_ticket_comparative/report_ticket_comparative.repository";
import {
    ReportTicketComparativeEntity
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/report_ticket_comparative.entity";
import {ReportEntityFilters} from "@dropDesk/presentation/components/filters/report_entity_filters";

@injectable()
export class GetReportTicketComparativeUseCase {
    private _repository: ReportTicketComparativeRepository;

    constructor(@inject(ReportTicketComparativeRepository) repository: ReportTicketComparativeRepository) {
        this._repository = repository;
    }

    public call(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<ReportTicketComparativeEntity> {
        return this._repository.get(period, comparePeriod, filters);
    }
}
